import React, {useState, useEffect} from 'react';
import {useParams, useLocation} from "react-router-dom";
import {useDispatch, useSelector} from 'react-redux';

import { ALERT_TYPE, OPERATION_MODE, REQUEST_METHOD, ShowToastMessage, dataTaggerActionClear, dataTaggerActionSet } from '@laramie/ui';
import { useForm, useLista, useManagedContext, useNav, useNavigateWithFilters, useUnsavedChangesGuard, useFormErrors } from '../../components/hooks';
import {APIS} from '../../config/apis';
import {ServerRequest} from '../../utils/apiweb';

import {Loading, InputPercent, InputEntidad, InputLista, SectionHeading, Accordion, FormError, FormLabel} from '../../components/common';
import {getDateId} from '../../utils/convert';
import DataTaggerFormRedux from '../../components/controls/DataTaggerFormRedux';
import {useMemo} from 'react';
import {MESSAGE_MODALS} from '../../context/custom/MessageModalContext';
import {isEmptyString} from '../../utils/validator';
import {VALIDATION_MESSAGE} from '../../consts/validationMessage';
import {TIPS} from "../../consts/tips";

function TasaView() {

    //parametros url
    const params = useParams();
    const location = useLocation();
    const previousFilters = location.state?.filters;
    const {showMessageModal} = useManagedContext()

    //variables
    const entityInit = {
        tasa: {
            id: 0,
            codigo: '',
            idTipoTributo: 0,
            idCategoriaTasa: 0,
            descripcion: '',
            porcentajeDescuento: 0
        },
        subtasas: [],
        archivos: [],
        observaciones: [],
        etiquetas: []
    };

    //hooks
    const navigate = useNav()
    const navigateWithFilters = useNavigateWithFilters(() => previousFilters || null);

    const [state, setState] = useState({
        id: params.id ? parseInt(params.id) : 0,
        mode: params.mode,
        loading: false,
        entity: entityInit,
    });

    const [processKey, setProcessKey] = useState(null);
    const [pendingChange, setPendingChange] = useState(false);

    const {allowNavigation} = useUnsavedChangesGuard(pendingChange);

    const mount = () => {

        const _processKey = `Tasa_${state.id ?? 0}_${getDateId()}`;
        setProcessKey(_processKey);

        if (state.id > 0) {
            FindTasa();
        } else {
            dispatch(dataTaggerActionSet(_processKey, {
                Archivo: [],
                Observacion: [],
                Etiqueta: []
            }));
        }

        const unmount = () => {
        }
        return unmount;
    }
    useEffect(mount, []);

    useEffect(() => {
        if (processKey && state.entity.tasa.id > 0) {
            dispatch(dataTaggerActionSet(processKey, {
                Archivo: state.entity.archivos,
                Observacion: state.entity.observaciones,
                Etiqueta: state.entity.etiquetas
            }));
        }
    }, [processKey, state.entity]);

    const [formValues, formHandle, , formSet] = useForm({
        codigo: '',
        idTipoTributo: 0,
        idCategoriaTasa: 0,
        descripcion: '',
        porcentajeDescuento: 0
    });

    const dispatch = useDispatch();
    const dataTagger = useSelector((state) => state.dataTagger.data);

    const isNoHeader = useMemo(() => window.location.pathname.split('/')[2] === 'nh', [window.location.pathname])

    const [tasasOpen, setTasasOpen] = useState(true);

    const { errorOf, validate } = useFormErrors(getErrors);

    //handles
    const formHandleProxy = (event) => {
        formHandle(event);
        setPendingChange(true);
    }
    const handleClickGuardar = () => {
        if (Object.keys(getErrors()).length > 0) setTasasOpen(true);

        if (validate()) {
            if (state.id === 0) {
                AddTasa();
            } else {
                ModifyTasa();
            }
        }
        ;
    }

    const handleClickSalir = () => {
        if (!pendingChange) {
            dispatch(dataTaggerActionClear(processKey));
            window.close()
        } else showMessageModal({
            ...MESSAGE_MODALS.CONFIRM_SALIR, onConfirm: () => {
                allowNavigation();
                window.close();
            }
        })
    }

    const handleClickVolver = () => {
        if (!pendingChange) dispatch(dataTaggerActionClear(processKey));
        navigateWithFilters(`/tasas`);
    }

    // Callbacks

    const callbackNoSuccess = (response) => {
        response.json()
            .then((error) => {
                const message = error.message;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
            return {...prevState, loading: false};
        });
    }
    const callbackSuccessFindTasa = (response) => {
        response.json()
            .then((data) => {
                setState(prevState => {
                    return {...prevState, loading: false, entity: data};
                });
                setPendingChange(false);
                formSet({
                    codigo: data.tasa.codigo,
                    idTipoTributo: data.tasa.idTipoTributo,
                    idCategoriaTasa: data.tasa.idCategoriaTasa,
                    descripcion: data.tasa.descripcion,
                    porcentajeDescuento: data.tasa.porcentajeDescuento
                });
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    }

    // Functions

    function getErrors() {
        const errors = {};

        if (formValues.codigo.length === 0) errors.codigo = VALIDATION_MESSAGE.REQUIRED;
        if (formValues.idCategoriaTasa <= 0) errors.idCategoriaTasa = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.descripcion.length === 0) errors.descripcion = VALIDATION_MESSAGE.REQUIRED;
        if (formValues.porcentajeDescuento > 100) errors.porcentajeDescuento = 'No puede superar 100';
        if (formValues.porcentajeDescuento < 0) errors.porcentajeDescuento = 'No puede ser negativo';

        return errors;
    }

    function FindTasa() {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const paramsUrl = `/${state.id}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.TASA,
            paramsUrl,
            null,
            callbackSuccessFindTasa,
            callbackNoSuccess,
            callbackError
        );

    }

    function AddTasa() {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const callbackSuccess = (response) => {
            response.json()
                .then((row) => {
                    ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, "Tasa ingresada correctamente", () => {
                        dispatch(dataTaggerActionClear(processKey));
                        setState(prevState => {
                            return {...prevState, loading: false};
                        });
                        allowNavigation();
                        if (isNoHeader) window.close()
                        else navigate({
                            to: `/tasa/edit/${row.tasa.id}`,
                            refresh: true,
                            replace: true,
                        })
                    });
                })
                .catch((error) => {
                    const message = 'Error procesando respuesta: ' + error;
                    ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                    setState(prevState => {
                        return {...prevState, loading: false};
                    });
                });
        };

        const dataBody = {
            tasa: {
                ...state.entity.tasa,
                codigo: formValues.codigo,
                idTipoTributo: !isEmptyString(formValues.idTipoTributo) ? parseInt(formValues.idTipoTributo) : 0,
                idCategoriaTasa: parseInt(formValues.idCategoriaTasa),
                descripcion: formValues.descripcion,
                porcentajeDescuento: formValues.porcentajeDescuento
            },
            archivos: (dataTagger[processKey]) ? dataTagger[processKey].Archivo.filter(f => f.state !== 'o') : [],
            observaciones: (dataTagger[processKey]) ? dataTagger[processKey].Observacion.filter(f => f.state !== 'o') : [],
            etiquetas: (dataTagger[processKey]) ? dataTagger[processKey].Etiqueta.filter(f => f.state !== 'o') : [],
        };

        ServerRequest(
            REQUEST_METHOD.POST,
            null,
            true,
            APIS.URLS.TASA,
            null,
            dataBody,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }

    function ModifyTasa() {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const callbackSuccess = (response) => {
            ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, "Tasa actualizada correctamente", () => {
                dispatch(dataTaggerActionClear(processKey));
                callbackSuccessFindTasa(response);
            });
        };

        const dataBody = {
            tasa: {
                ...state.entity.tasa,
                codigo: formValues.codigo,
                idTipoTributo: !isEmptyString(formValues.idTipoTributo) ? parseInt(formValues.idTipoTributo) : 0,
                idCategoriaTasa: parseInt(formValues.idCategoriaTasa),
                descripcion: formValues.descripcion,
                porcentajeDescuento: formValues.porcentajeDescuento
            },
            archivos: (dataTagger[processKey]) ? dataTagger[processKey].Archivo.filter(f => f.state !== 'o') : [],
            observaciones: (dataTagger[processKey]) ? dataTagger[processKey].Observacion.filter(f => f.state !== 'o') : [],
            etiquetas: (dataTagger[processKey]) ? dataTagger[processKey].Etiqueta.filter(f => f.state !== 'o') : [],
            //subtasas: state.entity.subTasas.filter(f => f.state !== 'o'),

        };
        const paramsUrl = `/${state.id}`;

        ServerRequest(
            REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.TASA,
            paramsUrl,
            dataBody,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }

    return (
        <>

            <Loading visible={state.loading}></Loading>

            <SectionHeading
                titles={[
                    {title: 'Entidades'},
                    {title: 'Tasas', url: '/tasas'},
                    {title: state.id === 0 ? 'Nueva' : `Código: ${state.entity.tasa.codigo}`},
                ]}
            />

            <div className="m-top-20">

                <section className='section-accordion'>

                    <div className="m-top-20 m-bottom-20">
                        <Accordion title="Tasas" open={tasasOpen} onToggle={setTasasOpen}>
                            <div className='row form-basic'>
                                <div className="mb-3 col-12 col-md-2">
                                    <FormLabel htmlFor="codigo" required>Código</FormLabel>
                                    <input
                                        name="codigo"
                                        type="text"
                                        placeholder=""
                                        className={`form-control ${errorOf('codigo') ? 'is-invalid' : ''}`}
                                        value={formValues.codigo}
                                        onChange={formHandleProxy}
                                        disabled={state.mode === OPERATION_MODE.VIEW}
                                    />
                                    <FormError message={errorOf('codigo')} />
                                </div>
                                <div className="mb-3 col-12 col-md-2">
                                    <label htmlFor="idTipoTributo" className="form-label">Tipo tributo</label>
                                    <InputLista
                                        name="idTipoTributo"
                                        textItemZero="Todos los tributos"
                                        className="form-control"
                                        value={formValues.idTipoTributo}
                                        onChange={formHandleProxy}
                                        lista="TipoTributo"
                                        disabled={state.mode === OPERATION_MODE.VIEW}
                                    />
                                    <FormError />
                                </div>
                                <div className="mb-3 col-12 col-md-2">
                                    <FormLabel htmlFor="idCategoriaTasa" required>Categoría</FormLabel>
                                    <InputEntidad
                                        name="idCategoriaTasa"
                                        placeholder=""
                                        className={`form-control ${errorOf('idCategoriaTasa') ? 'is-invalid' : ''}`}
                                        title="Categoría"
                                        tipName={TIPS.NAME.MODALS.CATEGORIA_TASA_MODAL}
                                        value={formValues.idCategoriaTasa}
                                        onChange={formHandleProxy}
                                        disabled={state.mode === OPERATION_MODE.VIEW}
                                        entidad="CategoriaTasa"
                                    />
                                    <FormError message={errorOf('idCategoriaTasa')} />
                                </div>
                                <div className="mb-3 col-12 col-md-4">
                                    <FormLabel htmlFor="descripcion" required>Descripción</FormLabel>
                                    <input
                                        name="descripcion"
                                        type="text"
                                        placeholder=""
                                        className={`form-control ${errorOf('descripcion') ? 'is-invalid' : ''}`}
                                        value={formValues.descripcion}
                                        onChange={formHandleProxy}
                                        disabled={state.mode === OPERATION_MODE.VIEW}
                                        maxLength={250}
                                    />
                                    <FormError message={errorOf('descripcion')} />
                                </div>
                                <div className="mb-3 col-12 col-md-2">
                                    <label htmlFor="porcentajeDescuento" className="form-label">Descuento</label>
                                    <InputPercent
                                        name="porcentajeDescuento"
                                        placeholder=""
                                        className={`form-control ${errorOf('porcentajeDescuento') ? 'is-invalid' : ''}`}
                                        value={formValues.porcentajeDescuento}
                                        onChange={formHandleProxy}
                                        disabled={state.mode === OPERATION_MODE.VIEW}
                                    />
                                    <FormError message={errorOf('porcentajeDescuento')} />
                                </div>
                            </div>
                        </Accordion>

                        <div style={{display: "none"}}>
                            <Accordion title="Subtasas">
                                {/* TODO: Insertar grilla Subtasa */}
                            </Accordion>
                        </div>

                        <div className="m-top-20">
                            <Accordion title="Información adicional">
                                <DataTaggerFormRedux
                                    title="Información adicional de Tasa"
                                    processKey={processKey}
                                    entidad="Tasa"
                                    idEntidad={state.id}
                                    disabled={state.mode === OPERATION_MODE.VIEW}
                                    onChange={(row) => setPendingChange(true)}
                                />
                            </Accordion>
                        </div>
                    </div>
                </section>
            </div>

            <footer className='footer footer-action'>
                <div className='footer-action-container'>
                    {isNoHeader ? (
                        <button className="btn back-button float-start" onClick={handleClickSalir}>Volver</button>
                    ) : (
                        <button className="btn back-button float-start"
                                onClick={(event) => handleClickVolver()}>Volver</button>
                    )}
                    {state.mode !== OPERATION_MODE.VIEW &&
                        <button
                            className={pendingChange ? "btn action-button float-end" : "btn action-button btn-disabled float-end"}
                            onClick={(event) => handleClickGuardar()}
                            disabled={!pendingChange}
                        >
                            Guardar
                        </button>
                    }
                </div>
            </footer>

        </>
    )
}

export default TasaView;
